(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fotric-product-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fotric-delivery-estimate')) {
  customElements.define('fotric-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.updateDates();
      this.timer = setInterval(() => this.updateDates(), 60000);
      this.onVisible = () => { if (!document.hidden) this.updateDates(); };
      document.addEventListener('visibilitychange', this.onVisible);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisible);
    }
    updateDates() {
      const now = new Date();
      const base = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
      const key = base.toISOString().slice(0,10);
      if (this.day === key) return;
      const locale = this.dataset.locale || 'en';
      let format;
      try { format = new Intl.DateTimeFormat(locale, {month:'short',day:'numeric',timeZone:'UTC'}); }
      catch { format = new Intl.DateTimeFormat('en', {month:'short',day:'numeric',timeZone:'UTC'}); }
      const offset = days => { const value = new Date(base); value.setUTCDate(value.getUTCDate()+days); return format.format(value); };
      const values = {ordered:offset(0),ready:offset(2),delivered:offset(7)+' – '+offset(9)};
      for (const [name,value] of Object.entries(values)) this.querySelector('[data-date="'+name+'"]').textContent=value;
      this.querySelector('ol').hidden=false;
      this.day=key;
    }
  });
}

if (!customElements.get('fotric-benefits-info')) {
  customElements.define('fotric-benefits-info', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.fotric-benefits__help');
      const restore = () => {
        document.documentElement.style.overflow = this.oldOverflow ?? '';
        if(trigger.isConnected) trigger.focus({preventScroll:true});
      };
      const close = () => { dialog.close(); restore(); };
      trigger.addEventListener('click', () => {
        this.oldOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        dialog.scrollTop = 0;
        document.documentElement.style.overflow = 'hidden';
      }, options);
      this.querySelector('.fotric-benefits__close').addEventListener('click',close,options);
      dialog.addEventListener('keydown', e => {
        if(e.key !== 'Tab') return;
        const items = [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length);
        const first=items[0], last=items[items.length-1];
        if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
      },options);
      dialog.addEventListener('click', e => {
        const rect = dialog.getBoundingClientRect();
        if(e.target === dialog && (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom)) close();
      },options);
      dialog.addEventListener('cancel', e => {e.preventDefault();close();},options);
    }
    disconnectedCallback() {
      if(this.querySelector('dialog')?.open) document.documentElement.style.overflow = this.oldOverflow ?? '';
      this.abort?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fotric-vat-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fotric-vat-guide')) {
  class FotricVatGuide extends HTMLElement {
    static active = null;
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.isProduct = this.dataset.mode !== 'page';
      this.formId = this.dataset.formId;
      this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
      this.productSection = this.closest('.shopify-section') || this.closest('main') || document;
      this.on(this, 'click', e => this.click(e));
      this.on(window, 'popstate', e => {
        if (this.dialog?.open && e.state?.fvToken !== this.token) this.hide();
      });
      if (!this.isProduct) {
        this.scope = this;
        this.bindForm();
        this.setReturnLink();
        if (this.querySelector('[data-result]')) this.querySelector('[data-result]').focus();
        if (location.hash === '#' + this.formId) this.querySelector('.fv-form-area')?.scrollIntoView();
      } else {
        const result = this.querySelector('template')?.content.querySelector('[data-result]');
        if (result && location.hash === '#' + this.formId) this.open(true, false);
      }
    }
    on(target, name, callback) { target.addEventListener(name, callback, { signal: this.signal }); }
    click(e) {
      if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const trigger = e.target.closest('[data-open],[data-request],[data-close],[data-back]');
      if (!trigger) return;
      if (trigger.matches('[data-open]')) { e.preventDefault(); this.open(false); }
      if (trigger.matches('[data-close]')) { e.preventDefault(); this.close(); }
      if (trigger.matches('[data-back]')) { e.preventDefault(); this.view(false); }
      if (trigger.matches('[data-request]')) {
        if (this.isProduct) { e.preventDefault(); this.view(true); }
        else { e.preventDefault(); this.querySelector('.fv-form-area').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); this.querySelector('input[type="email"]')?.focus({ preventScroll: true }); }
      }
    }
    createDialog() {
      if (this.dialog) return;
      this.dialog = this.querySelector('template').content.firstElementChild.cloneNode(true);
      document.body.append(this.dialog);
      this.scope = this.dialog;
      this.on(this.dialog, 'click', e => {
        this.click(e);
        if (e.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close();
        }
      });
      this.on(this.dialog, 'cancel', e => { e.preventDefault(); this.close(); });
      this.on(this.dialog, 'close', () => { if (!this.dialog.open) this.restoreScroll(); });
      const full = this.dialog.querySelector('[data-full]');
      const target = new URL(full.href, location.href);
      target.searchParams.set('from', location.pathname + location.search);
      full.href = target.href;
      this.bindForm();
    }
    open(quote = false, addHistory = true) {
      const other = FotricVatGuide.active && FotricVatGuide.active !== this ? FotricVatGuide.active : null;
      const replaceHistory = other?.historyOwned && history.state?.fvToken === other.token;
      if (other) other.hide();
      this.createDialog();
      if (!this.dialog.open) {
        this.origin = document.activeElement;
        this.oldOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        FotricVatGuide.active = this;
        this.token = 'fv-' + Math.random().toString(36).slice(2);
        this.historyOwned = addHistory;
        if (addHistory) history[replaceHistory ? 'replaceState' : 'pushState']({ ...history.state, fvToken: this.token }, '', '#FvDialog-' + this.formId);
      }
      this.view(quote);
    }
    view(quote) {
      this.scope.querySelectorAll('[data-guide]').forEach(el => { el.hidden = quote; });
      this.scope.querySelector('[data-quote]').hidden = !quote;
      this.scope.querySelector('[data-quote-action]').hidden = !quote || !this.scope.querySelector('[data-model]');
      this.scope.querySelector('.fv-scroll').scrollTop = 0;
      if (quote) {
        this.syncProduct();
        this.protect();
        (this.scope.querySelector('[data-result]') || this.scope.querySelector('input[type="email"]'))?.focus({ preventScroll: true });
      } else this.scope.querySelector('[data-close]').focus({ preventScroll: true });
    }
    close() {
      if (!this.dialog?.open) return;
      const back = this.historyOwned && history.state?.fvToken === this.token;
      this.hide();
      if (back) history.back();
    }
    hide() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
      this.origin?.focus({ preventScroll: true });
    }
    restoreScroll() {
      if (!this.locked) return;
      document.documentElement.style.overflow = this.oldOverflow;
      this.locked = false;
      if (FotricVatGuide.active === this) FotricVatGuide.active = null;
    }
    protect() {
      const form = this.scope.querySelector('.fv-form');
      if (!form || this.captchaBound) return;
      const attach = () => {
        if (window.Shopify?.captcha?.protect) {
          try { window.Shopify.captcha.protect(form); this.captchaBound = true; } catch (_) { return false; }
          return true;
        }
        return false;
      };
      if (attach() || this.captchaTimer) return;
      let attempts = 0;
      this.captchaTimer = setInterval(() => {
        if (!this.isConnected || attach() || ++attempts >= 50) { clearInterval(this.captchaTimer); this.captchaTimer = null; }
      }, 100);
    }
    bindForm() {
      const form = this.scope.querySelector('.fv-form');
      if (!form || !form.querySelector('[data-model]')) return;
      const registration = form.querySelector('[data-registration]');
      const delivery = form.querySelector('[data-delivery]');
      const validate = () => delivery?.setCustomValidity(registration.value && delivery.value && registration.value !== delivery.value ? this.dataset.mismatch : '');
      this.on(form, 'change', validate);
      this.on(form, 'focusin', () => this.protect());
      this.on(form.querySelector('[data-model]'), 'input', e => { e.target.dataset.edited = 'true'; });
      this.on(form, 'submit', e => {
        validate();
        if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
        const url = new URL(location.href);
        url.hash = this.formId;
        url.searchParams.delete('contact_posted');
        const selected = form.querySelector('[data-variant-id]')?.value;
        if (this.isProduct && selected) url.searchParams.set('variant', selected);
        if (form.elements.return_to) form.elements.return_to.value = url.pathname + url.search + url.hash;
        const lines = ['EU B2B 0% VAT Purchase Request'];
        for (const [key, value] of new FormData(form)) if (key.startsWith('contact[') && key !== 'contact[body]' && String(value).trim()) lines.push(key.slice(8, -1) + ': ' + String(value));
        form.elements['contact[body]'].value = lines.join('\n');
      });
    }
    syncProduct() {
      if (!this.isProduct) return;
      const productForm = [...this.productSection.querySelectorAll('form[action*="/cart/add"]')].find(form => this.variants.some(v => String(v.id) === String(form.elements.id?.value)));
      const id = productForm?.elements.id?.value;
      const variant = this.variants.find(v => String(v.id) === String(id));
      const form = this.scope.querySelector('.fv-form');
      if (!form) return;
      const variantInput = form.querySelector('[data-variant-id]');
      if (id && variantInput) variantInput.value = id;
      const label = this.scope.querySelector('[data-variant-label]');
      if (variant && label) label.textContent = variant.title;
      const productURL = new URL(location.href);
      productURL.hash = '';
      if (id) productURL.searchParams.set('variant', id);
      form.querySelector('[data-product-url]').value = productURL.href;
      const model = form.querySelector('[data-model]');
      if (model && !model.dataset.edited) {
        this.baseModel ||= model.value.trim();
        const quantity = productForm?.elements.quantity?.value || '1';
        model.value = this.baseModel + (variant && variant.title !== 'Default Title' ? ' · ' + variant.title : '') + ' × ' + quantity;
      }
    }
    setReturnLink() {
      const raw = new URL(location.href).searchParams.get('from');
      if (!raw) return;
      try {
        const url = new URL(raw, location.origin);
        if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) return;
        const link = this.querySelector('[data-return]');
        link.href = url.pathname + url.search;
        link.hidden = false;
      } catch (_) {}
    }
    disconnectedCallback() {
      this.restoreScroll();
      this.controller?.abort();
      this.dialog?.remove();
      this.dialog = null;
      clearInterval(this.captchaTimer);
      this.captchaTimer = null;
      this.controller = null;
      this.captchaBound = false;
    }
  }
  customElements.define('fotric-vat-guide', FotricVatGuide);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-inline-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const desktop = window.matchMedia('(min-width:1100px)');
  const finePointer = window.matchMedia('(hover:hover) and (pointer:fine)');
  function initialise(scope) {
    scope.querySelectorAll('.fotric-unified-navigation').forEach(nav => {
      if (nav.dataset.unifiedReady) return;
      nav.dataset.unifiedReady = 'true';
      const items = [...nav.querySelectorAll(':scope > ul > .list-menu-item')];
      let active = null, timer, restoring = false;
      const trigger = item => item?.querySelector(':scope > a');
      const panel = item => item?.querySelector(':scope > .header__mega-menu,:scope > .header__submenu');
      const measure = () => {
        const header = nav.closest('header');
        const bounds = header?.getBoundingClientRect();
        nav.style.setProperty('--fotric-menu-top', Math.max(0, bounds?.bottom || 100) + 'px');
        if (active && panel(active)?.classList.contains('fotric-resource-menu') && bounds) {
          const width = Math.min(1440, window.innerWidth - 48);
          panel(active).style.setProperty('--fotric-mega-left', ((window.innerWidth - width) / 2 - bounds.left) + 'px');
        }
        if (active && panel(active)?.classList.contains('header__submenu') && bounds) {
          const anchor = trigger(active).getBoundingClientRect();
          const width = Math.min(panel(active).getBoundingClientRect().width || 320, window.innerWidth - 32);
          const left = Math.max(16, Math.min(anchor.left + anchor.width / 2 - width / 2, window.innerWidth - width - 16));
          panel(active).style.setProperty('--fotric-dropdown-left', (left - bounds.left) + 'px');
        }
      };
      function setActive(next) {
        clearTimeout(timer);
        items.forEach(item => {
          const open = item === next && Boolean(panel(item));
          item.classList.toggle('fotric-menu-active', open);
          item.classList.toggle('list-menu--megamenu-visible', open && item.classList.contains('list-menu--megamenu'));
          if (panel(item)) {
            trigger(item).setAttribute('aria-expanded', String(open));
            if (!open) panel(item).style.removeProperty('--fotric-dropdown-left');
          }
        });
        active = panel(next) ? next : null;
        if (active) measure();
      }
      const itemFrom = target => items.find(item => item.contains(target));
      items.forEach((item, index) => {
        const content = panel(item);
        if (!content) return;
        content.id ||= nav.id + '-panel-' + index;
        trigger(item).setAttribute('aria-controls', content.id);
      });
      nav.addEventListener('pointerover', event => {
        if (!desktop.matches || !finePointer.matches || event.pointerType === 'touch') return;
        const item = itemFrom(event.target);
        clearTimeout(timer);
        if (item && item !== active) setActive(item);
      });
      nav.addEventListener('pointerleave', () => {
        if (finePointer.matches) timer = setTimeout(() => setActive(null), 180);
      });
      nav.addEventListener('focusin', event => {
        if (!restoring && desktop.matches) setActive(itemFrom(event.target));
      });
      nav.addEventListener('focusout', event => {
        if (event.relatedTarget) {
          if (!nav.contains(event.relatedTarget)) setActive(null);
        } else {
          queueMicrotask(() => {
            if (!nav.matches(':hover') && !nav.contains(document.activeElement)) setActive(null);
          });
        }
      });
      nav.addEventListener('click', event => {
        const item = itemFrom(event.target);
        if (!desktop.matches || !panel(item) || !trigger(item).contains(event.target)) return;
        if (event.pointerType === 'touch' || !finePointer.matches) {
          if (item.dataset.touchOpen !== 'true') {
            event.preventDefault();
            items.forEach(sibling => delete sibling.dataset.touchOpen);
            item.dataset.touchOpen = 'true';
            setActive(item);
          }
        }
      });
      nav.addEventListener('keydown', event => {
        const item = itemFrom(event.target);
        if (!desktop.matches || !item) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          setActive(null);
          restoring = true;
          trigger(item).focus();
          restoring = false;
        } else if (event.target === trigger(item) && panel(item) && (event.key === 'ArrowDown' || event.key === ' ')) {
          event.preventDefault();
          setActive(item);
          panel(item).querySelector('button,[href]')?.focus();
        }
      });
      nav.addEventListener('fotric:close', () => {
        items.forEach(item => delete item.dataset.touchOpen);
        setActive(null);
      });
      mountMobile(nav, items);
      setActive(null);
    });
  }

  function mountMobile(nav, items) {
    const header = nav.closest('header');
    const drawer = header?.querySelector('header-drawer');
    const list = drawer?.querySelector('.menu-drawer__navigation > ul');
    if (!list) return;
    const path = anchor => new URL(anchor.href, document.baseURI).pathname.replace(/\/$/, '') || '/';
    items.filter(item => item.querySelector('.fotric-use-menu')).forEach(item => {
      const source = item.querySelector('.fotric-use-menu');
      const parentLink = item.querySelector(':scope > a');
      const row = [...list.children].find(li => {
        const link = li.querySelector(':scope > details > summary a');
        return link && path(link) === path(parentLink);
      });
      const target = row?.querySelector('.menu-drawer__inner-submenu > ul');
      if (!target || row.dataset.frnUses === 'true') return;
      row.dataset.frnUses = 'true';
      target.classList.add('fotric-use-menu', 'fotric-use-mobile');
      target.replaceChildren(...[...source.children].map(child => child.cloneNode(true)));
    });
    items.filter(item => item.querySelector('.fotric-resource-menu')).forEach(item => {
      const source = item.querySelector('.fotric-resource-menu');
      const parentLink = item.querySelector(':scope > a');
      const row = [...list.children].find(li => {
        const link = li.querySelector(':scope > details > summary a');
        return link && path(link) === path(parentLink);
      });
      const target = row?.querySelector('.menu-drawer__inner-submenu > ul');
      if (!target || row.dataset.frnMobile === 'true') return;
      row.dataset.frnMobile = 'true';
      const outer = document.createElement('li');
      outer.className = 'frn-mobile-host';
      const mobile = document.createElement('div');
      mobile.className = 'frn-mobile-menu';
      const categoryPanels = [...source.querySelectorAll('.frn-panel')];
      categoryPanels.forEach((panel, index) => {
        const group = document.createElement('div');
        group.className = 'frn-mobile-group';
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'frn-mobile-toggle';
        toggle.id = nav.id + '-mobile-tab-' + index;
        const heading = panel.querySelector('.frn-collection-link');
        const text = (panel.querySelector('.frn-view-all') || heading).cloneNode(true);
        toggle.append(document.createTextNode(heading.textContent.replace('→', '').trim()));
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '+';
        toggle.append(icon);
        const body = document.createElement('div');
        body.className = 'frn-mobile-body';
        body.id = nav.id + '-mobile-panel-' + index;
        body.setAttribute('role', 'region');
        body.setAttribute('aria-labelledby', toggle.id);
        body.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', body.id);
        text.className = 'frn-mobile-collection';
        const products = panel.querySelector('.frn-products').cloneNode(true);
        products.className = 'frn-mobile-products';
        products.querySelectorAll('img').forEach(img => { img.sizes = '64px'; });
        body.append(products, text);
        group.append(toggle, body);
        mobile.append(group);
      });
      source.querySelectorAll('.frn-catalog-link,.frn-other-links a').forEach(link => {
        const copy = link.cloneNode(true);
        copy.className = 'frn-mobile-all';
        mobile.append(copy);
      });
      const sourceTools = source.querySelector('.frn-tools');
      if (sourceTools) {
        const tools = sourceTools.cloneNode(true);
        tools.className = 'frn-mobile-tools';
        mobile.prepend(tools);
      }
      mobile.addEventListener('click', event => {
        const button = event.target.closest('.frn-mobile-toggle');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        const open = button.getAttribute('aria-expanded') !== 'true';
        mobile.querySelectorAll('.frn-mobile-toggle').forEach(toggle => {
          const chosen = toggle === button && open;
          toggle.setAttribute('aria-expanded', String(chosen));
          toggle.querySelector('span').textContent = chosen ? '−' : '+';
          toggle.nextElementSibling.hidden = !chosen;
        });
      }, true);
      const summary = row.querySelector(':scope > details > summary');
      const summaryLink = summary?.querySelector('a');
      summaryLink?.addEventListener('click', event => {
        if (desktop.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        summary.click();
      }, true);
      outer.append(mobile);
      target.replaceChildren(outer);
    });
  }
  function closeAll() {
    document.querySelectorAll('.fotric-unified-navigation').forEach(nav => nav.dispatchEvent(new Event('fotric:close')));
  }
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.fotric-unified-navigation')) closeAll();
  });
  window.addEventListener('resize', closeAll, { passive:true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once:true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fotric-resource-tabs')) {
  customElements.define('fotric-resource-tabs', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.abort) return;
        this.abort = new AbortController();
        const options = { signal:this.abort.signal };
        const tabs = [...this.querySelectorAll('.frn-tab')];
        const panels = [...this.querySelectorAll('.frn-panel')];
        const select = tab => {
          clearTimeout(this.timer);
          tabs.forEach(button => {
            const chosen = button === tab;
            button.dataset.frnSelected = String(chosen);
            button.setAttribute('aria-expanded', String(chosen));
          });
          panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab), options);
          tab.addEventListener('focus', () => select(tab), options);
          tab.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') this.timer = setTimeout(() => select(tab), 120);
          }, options);
          tab.addEventListener('pointerleave', () => clearTimeout(this.timer), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else if (event.key === 'ArrowRight') {
              event.preventDefault();
              panels.find(panel => !panel.hidden)?.querySelector('a')?.focus();
              return;
            } else return;
            event.preventDefault();
            event.stopPropagation();
            tabs[next].focus();
          }, options);
        });
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      clearTimeout(this.timer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
